export const getData = (locale = 'en') => {
    return fetch(`https://oprdev3.xyz/api/gis?locale=${locale}`);
};
